'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dSelected$002dCredential from "./presto.types$-Selected-Credential.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SelectedCredential$() {
}
export { $c_Lpresto_types$SelectedCredential$ as $c_Lpresto_types$SelectedCredential$ };
$p = $c_Lpresto_types$SelectedCredential$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SelectedCredential$;
/** @constructor */
function $h_Lpresto_types$SelectedCredential$() {
}
export { $h_Lpresto_types$SelectedCredential$ as $h_Lpresto_types$SelectedCredential$ };
$h_Lpresto_types$SelectedCredential$.prototype = $p;
$p.l = (function() {
  return "SelectedCredential";
});
$p.cGw = (function(x$0) {
  return new $j_presto$002etypes$0024$002dSelected$002dCredential.$c_Lpresto_types$SelectedCredential(x$0.j(0), (!(!x$0.j(1))));
});
var $d_Lpresto_types$SelectedCredential$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SelectedCredential$, "presto.types$SelectedCredential$", ({
  a1v: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$SelectedCredential$ as $d_Lpresto_types$SelectedCredential$ };
var $n_Lpresto_types$SelectedCredential$;
function $m_Lpresto_types$SelectedCredential$() {
  if ((!$n_Lpresto_types$SelectedCredential$)) {
    $n_Lpresto_types$SelectedCredential$ = new $c_Lpresto_types$SelectedCredential$();
  }
  return $n_Lpresto_types$SelectedCredential$;
}
export { $m_Lpresto_types$SelectedCredential$ as $m_Lpresto_types$SelectedCredential$ };
//# sourceMappingURL=presto.types$-Selected-Credential$.js.map
